import React, { useState } from "react";
import LiveData from "./LiveData";
import PouchData from "./PouchData";

const InvestigationCash = () => {
  const [showLive, setShowLive] = useState(true);

  return <LiveData showLive={true} setShowLive={() => {}} />;
};

export default InvestigationCash;
